<div class="registration-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="mg-btm-32">Sign Up With:</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button role="button" class="btn signup-social-fb" (click)="facebookAuth()"></button>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button role="button" class="btn signup-social-google" (click)="googleAuth()"></button>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
      <button role="button" class="btn signup-social-apple" (click)="appleAuth()"></button>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center ">
      <h2 class="signIn_email">or Sign Up With Email</h2>
      <span class="hint-text">* Required field</span>
    </div>
  </div>
  <div class="row mg-top-18">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <app-alert [alertService]="alertService"></app-alert>
    </div>
    <form (ngSubmit)="onSubmit()" [formGroup]="registerForm" novalidate>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pad-tp-lft-rgt-24">
        <div class="form-group">
          <label>First Name*</label>
          <input type="text" class="form-control" formControlName="firstname" maxlength="20" />
          <app-validation-message [control]="registerForm.controls.firstname" class="form-error">
          </app-validation-message>
        </div>
        <div class="form-group">
          <label>Last Name*</label>
          <input type="text" class="form-control" formControlName="lastname" maxlength="20" />
          <app-validation-message [control]="registerForm.controls.lastname" class="form-error">
          </app-validation-message>
        </div>
        <div class="form-group">
          <label>Phone Number</label>
          <input type="tel" class="form-control" formControlName="phonenumber" maxlength="10" />
          <app-validation-message [control]="registerForm.controls.phonenumber" class="form-error"
            [updateOn]="updateTrigger.Dirty" ignoreDirtyValidationPattern="^[0-9]{1,10}$"></app-validation-message>
        </div>
        <div class="form-group">
          <label>ZIP Code*</label>
          <input type="text" class="form-control" formControlName="zipcode" maxlength="5" />
          <app-validation-message [control]="registerForm.controls.zipcode" class="form-error"></app-validation-message>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 leftDivider pad-tp-lft-rgt-24">
        <div class="form-group">
          <label>Email Address*</label>
          <input type="email" class="form-control" formControlName="email" maxlength="50" />
          <app-validation-message [control]="registerForm.controls.email" class="form-error"></app-validation-message>
        </div>
        <div formGroupName="passwords">
          <div class="form-group">
            <label>Create Password*</label>
            <input type="password" class="form-control" formControlName="password" />
            <app-validation-message [control]="registerForm['controls'].passwords['controls'].password" class="form-error"></app-validation-message>
            <div class="password-reqs text-left">
              <span class="hint-text">Your password must be at least 8 characters (20 max) with no spaces and meeting 2 of these 4 requirements:
                1 special character; 1 uppercase; 1 lowercase; 1 number.
              </span>
            </div>
          </div>
          <div class="form-group">
            <label>Confirm Password*</label>
            <input type="password" class="form-control" formControlName="confPw" />
            <app-validation-message [control]="registerForm['controls'].passwords['controls'].confPw" class="form-error"></app-validation-message>
          </div>
        </div>
        <div class="form-group signup-checkbox">
          <app-wb-selector [selectorType]="'checkbox'" [group]="registerForm" [controlName]="'addToEmail'" [inputId]="'addToEmail'" [labels]="checkBoxLabel" [value]="0"></app-wb-selector>
        </div>
        <div class="form-group">
          <button type="submit" class="btn wb-btn-default center-block" [disabled]="!registerForm.valid || loading">
            Sign Up
            <span *ngIf="loading" class="loading-animation"></span>
          </button>
        </div>
        <div class="text-center mg-top-18">
          <span role="button" (click)="showSignInModal()" class="forget-sign-link already-link"> Already have an account? Sign in</span>
        </div>
        <div class="text-center mg-top-12" *ngIf="auth0PasswordlessSignup">
          <span
            role="button"
            (click)="showModal('app-auth0-email-signup', false)"
            class="forget-sign-link already-link"
          >
            Sign up with email code (no password)
          </span>
        </div>
      </div>
    </form>
  </div>
</div>
